export const adaptProfesional = (profesionalData) => {    
    return {
        id: profesionalData?.idProfesional,
        displayName: profesionalData?.profesional,
        name: profesionalData?.profesional
    }
}

export const adaptProfesionalArray = (
    profesionales
) => {
    return structuredClone(profesionales?.profesionalesRIEV.valorEsperado)
        ?.map(profesional => adaptProfesional(profesional));
}